import React from "react";
import { BookOpenIcon, CalendarCheckIcon, ClipboardListIcon, GiftIcon, GlobeIcon, NotebookPenIcon, OrbitIcon, PlayCircleIcon, BoxIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images, offerItems } from "../../data/content";
const icons: Record<(typeof offerItems)[number]['icon'], BoxIcon> = {
  book: BookOpenIcon,
  gift: GiftIcon,
  practices: PlayCircleIcon,
  checklist: ClipboardListIcon,
  map: OrbitIcon,
  journal: NotebookPenIcon,
  calendar: CalendarCheckIcon
};
export function Offer() {
  return <section id="offer" className="bg-brand-950 px-3 py-16 sm:px-5 sm:py-24" data-id="element-245" data-mp="3jwjmjbi16li1">
      <div className="mx-auto max-w-2xl" data-id="element-246" data-mp="3nx3kghafht58">
        <div className="text-center" data-id="element-247" data-mp="3nyy65xtixpad">
          <p className="inline-block rounded-full bg-gold px-4 py-1.5 text-xs font-extrabold uppercase tracking-[0.14em] text-brand-950" data-id="element-248" data-mp="3swghtvyxeim2">
            Special launch offer
          </p>
          <h2 className="mt-4 font-display text-[30px] font-bold leading-tight text-white sm:text-5xl" data-id="element-249" data-mp="1klgmuoak4klz">
            Here’s everything you’ll receive
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-[28px] bg-white" data-id="element-250" data-mp="1fohvgdia2rrh">
          <img src={images.mockup} alt="Complete 7D Apometry Protocol bundle" className="h-auto w-full" loading="lazy" data-id="element-251" data-mp="1bll8kalpg9hq" />
          <div className="px-5 pb-8 sm:px-10" data-id="element-252" data-mp="16ns0td4r77fc">
            <ul className="divide-y divide-brand-100" data-id="element-253" data-mp="23chlfb7rme50">
              {offerItems.map(item => {
              const Icon = icons[item.icon];
              return <li key={item.label} className="flex items-center gap-3 py-3.5 text-[16px] font-semibold text-ink" data-id="element-254" data-mp="1zb5yxek6u911">
                    <span className="grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-brand-100 text-brand-700" data-id="element-255" data-mp="1uhbc429addxq">
                      <Icon className="h-5 w-5" aria-hidden="true" data-id="element-256" data-mp="2mzp1ddgk3rl7" />
                    </span>
                    {item.label}
                  </li>;
            })}
            </ul>

            <div className="mt-6 rounded-2xl bg-cream p-6 text-center" data-id="element-257" data-mp="315h5o916bnvm">
              <p className="text-sm font-bold uppercase tracking-wider text-ink-soft" data-id="element-258" data-mp="31690viquzjld">Total value of the system</p>
              <p className="mt-1 text-2xl font-bold text-urgent line-through decoration-2" data-id="element-259" data-mp="366emah6jc9v0">$147+ USD</p>
              <p className="mt-4 text-sm font-bold uppercase tracking-wider text-brand-700" data-id="element-260" data-mp="2sbcibzl90uku">Today you get everything for</p>
              <p className="mt-1 font-display text-7xl font-extrabold leading-none text-brand-800" data-id="element-261" data-mp="2ieg91rnj04f8">
                $27<span className="ml-1 align-top text-xl font-bold text-ink-soft" data-id="element-262" data-mp="2nelu2ozaisoc">USD</span>
              </p>
              <p className="mt-3 text-[15px] font-semibold text-ink" data-id="element-263" data-mp="29f2z6xvhpdtz">
                One-time payment · Lifetime access · No monthly fees · Instant download
              </p>
            </div>

            <div className="mt-5" data-id="element-264" data-mp="7meo62cltm3n">
              <ScarcityBar data-id="element-265" data-mp="7ng1yel08mp2" />
            </div>

            <CtaButton label="I want the 7D Apometry Protocol™" microcopy="$27 USD · Instant download · Lifetime access · 7-day guarantee" className="mt-6" data-id="element-266" data-mp="bo9p35qmhxgw" />

            <p className="mx-auto mt-4 flex max-w-md items-start justify-center gap-2 rounded-xl bg-brand-50 px-4 py-3 text-left text-sm font-medium text-brand-800" data-id="element-267" data-mp="1w6tz0o4zlypc">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-268" data-mp="25xf7r4edkjlz" />
              Currency conversion is automatic — you’ll see the price in your local currency at checkout.
            </p>

            <Countdown data-id="element-269" data-mp="2ftib2dkyqoai" />

            <p className="mt-8 text-center text-[15px] leading-relaxed text-ink-soft" data-id="element-270" data-mp="2fsqdwybpwii4">
              For $27, you’ll have a practical path to begin exploring Apometry without facing hundreds of pages of
              theory first.
            </p>
          </div>
        </div>
      </div>
    </section>;
}